import { useCallback, useEffect, useState } from 'react';
import { ExportFileEntity, ExportFileType } from './ExportFileTypes';

const FIELDS_KEY = 'Fields';
const SAVE_FLAG_KEY = 'SaveFields';

/**
 * Hook per la gestione del salvataggio in localStorage dei campi
 * selezionati per l'esportazione
 */
interface UseExportFileStorageDataOptions {
  type: ExportFileType;
  /**
   * Le esportazioni per i Bandi hanno un suffisso personalizzato
   * (ID del procedimento)
   */
  customKeySuffix?: string;
  entity: ExportFileEntity;
  onSelect: (fields: string[]) => void;
}
export function useExportFileStorageData(
  options: UseExportFileStorageDataOptions,
) {
  const { type, customKeySuffix, entity, onSelect } = options;
  const key = `${entity}_${type === 'xlsx' ? 'csv' : type}${
    customKeySuffix ?? ''
  }`;

  // Flag di salvataggio
  const [saveFlag, setSaveFlag] = useState(false);

  useEffect(() => {
    // Recupero il flag di salvataggio dei campi
    const saveFieldData = localStorage.getItem(`${key}${SAVE_FLAG_KEY}`);

    // Se non è indicato il salvataggio dei campi, non caricare nessun default
    if (!saveFieldData) return;
    const saveFieldValue = JSON.parse(saveFieldData);
    if (!saveFieldValue) return;

    // Se è presente un flag, lo imposto nello stato
    setSaveFlag(saveFieldValue);

    // Recupero i campi selezionati
    const fieldData = localStorage.getItem(`${key}${FIELDS_KEY}`);
    if (fieldData) {
      // Se esistono li imposto come valore attuale e come default
      const fields = JSON.parse(fieldData);
      onSelect(fields);
    }
  }, [key, onSelect]);

  /** Funzione per l'aggiornamento del localStorage, richiamata al salvataggio */
  const update = useCallback(
    (selectedFields: string[]) => {
      // Salvo il flag
      localStorage.setItem(`${key}${SAVE_FLAG_KEY}`, JSON.stringify(saveFlag));

      // Se il flag è attivo, salvo i campi selezionati
      if (saveFlag) {
        localStorage.setItem(
          `${key}${FIELDS_KEY}`,
          JSON.stringify(selectedFields),
        );
      }
    },
    [key, saveFlag],
  );

  return {
    saveFlag,
    setSaveFlag,
    update,
  };
}
